import { useGetUsProviderGroupClinics } from "./useGetUsProviderGroupClinics";

export function useUsProviderGroupClinicOptions() {
  const { data: usProviderGroupClinics, error, isError, isLoading } = useGetUsProviderGroupClinics();

  return {
    error,
    isError,
    isLoading,
    options:
      usProviderGroupClinics?.items?.map(clinic => ({
        label: clinic.name,
        value: clinic.id.toString(),
      })) ?? [],
  };
}
